import { useState } from 'react'

interface Props { userId?: string; name?: string; src?: string | null }

/** Key each image attempt so a changed URL/account never inherits another image's state. */
export function AccountAvatar({ userId, name, src }: Props) {
  const source = src?.trim() || null
  return <AvatarImage key={JSON.stringify([userId, source])} name={name} src={source}/>
}

function AvatarImage({ name, src }: Props) {
  const [state, setState] = useState<'loading' | 'loaded' | 'failed'>('loading')
  const initial = Array.from(name?.trim() || 'L')[0]!.toLocaleUpperCase()
  return <span className="account-avatar" data-image-state={src ? state : 'absent'} aria-hidden="true">
    <span className="account-avatar__initial">{initial}</span>
    {src && state !== 'failed' ? <img
      className="account-avatar__image" src={src} alt="" referrerPolicy="no-referrer"
      onLoad={event => setState(event.currentTarget.naturalWidth > 0 ? 'loaded' : 'failed')}
      onError={() => setState('failed')}
    /> : null}
  </span>
}
